export default __webpack_public_path__ + "static/media/profile.1394cfd4.jpeg";